import { compose } from 'recompose';
import { pathOr } from 'ramda';
import { connect } from 'react-redux';

import Options from '../components/Options';
import withMinInterval from '../../../containers/BrandBarber/hoc/withMinInterval';
import { LOCATIONS_ALL_ID } from '../../../containers/BrandBarber/constants';

const enhance = compose(
  withMinInterval,
  connect((state, ownProps) => {
    const selectedShop = ownProps.barberShops.find(shop => shop.id === ownProps.selectedLocation) || {};
    return {
      canUsePasscode: !(ownProps.selectedLocation === LOCATIONS_ALL_ID) && !!selectedShop.bookingCodeEnabled,
      shopBookNoPay: !(ownProps.selectedLocation === LOCATIONS_ALL_ID) && !!selectedShop.bookNoPay,
      calculateHourlyWagesEnabled: !(ownProps.selectedLocation === LOCATIONS_ALL_ID)
        && !!selectedShop.calculateHourlyWages,
      extendedHourlyWagesEnabled: !(ownProps.selectedLocation === LOCATIONS_ALL_ID)
        && pathOr(false, ['settings', 'extendedHourlyWages'])(selectedShop),
    };
  }),
);

export default enhance(Options);
